// Enum compartilhado para feedback de mensagens
export enum ChatMessageFeedback {
  Like,
  Dislike,
}

// Interface da mensagem (pode mover também se quiser)
export interface Message {
  id: string;
  role: string;
  content: string;
  hide: boolean;
  feedback?: ChatMessageFeedback;
  isFromHistory?: boolean;
}
